<!-- 2022-12-12 xiexiaodong -->
<template>
  <div class="navBar">
    <div class="nav_left">
      <div class="logo">
        <img src="@/assets/logo.png" alt="" />叁昶文化科技 管理系统
      </div>

      <!-- <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        :ellipsis="false"
        @select="handleSelect"
        router
      > -->
      <el-menu class="el-menu-demo" mode="horizontal" :ellipsis="false" router>
        <el-menu-item index="/index">工作台</el-menu-item>
        <el-sub-menu index="1" v-if="haveFirstAuth('001')">
          <template #title>人事管理</template>
          <el-menu-item
            class="HeadText"
            index="/user"
            v-if="haveSecond('0011_')"
            >员工管理</el-menu-item
          >
          <el-menu-item
            class="HeadText"
            index="/department"
            v-if="haveSecond('0012_')"
            >部门管理</el-menu-item
          >
        </el-sub-menu>
        <el-sub-menu index="2" v-if="haveFirstAuth('002')">
          <template #title>项目管理</template>
          <el-menu-item
            class="HeadText"
            index="/project"
            v-if="haveSecond('0021_')"
            >项目列表</el-menu-item
          >
          <el-menu-item class="HeadText" index="/preSalesProject"
            >售前项目</el-menu-item
          >
        </el-sub-menu>
        <el-sub-menu index="3" v-if="haveFirstAuth('003')">
          <template #title>流程管理</template>
          <el-menu-item
            class="HeadText"
            index="/process"
            v-if="haveSecond('0031_')"
            >流程列表</el-menu-item
          >
          <el-menu-item
            class="HeadText"
            index="/toDoList"
            v-if="haveSecond('0032_')"
            >待办事项</el-menu-item
          >
        </el-sub-menu>
        <el-sub-menu index="4" v-if="haveFirstAuth('004')">
          <template #title>采购管理</template>
          <el-menu-item
            class="HeadText"
            index="/purchase"
            v-if="haveSecond('0041_')"
            >产品资源库</el-menu-item
          >
          <el-menu-item
            class="HeadText"
            index="/suppliers"
            v-if="haveSecond('0042_')"
            >供应商档案</el-menu-item
          >
        </el-sub-menu>
        <!-- <el-sub-menu index="5" v-if="haveFirstAuth('005')">
          <template #title>客户管理</template>
          <el-menu-item class="HeadText" index="/connection" v-if="haveSecond('0051_')"
            >客户档案</el-menu-item
          >
        </el-sub-menu> -->

        <el-sub-menu index="7" v-if="haveFirstAuth('007')">
          <template #title>财务管理</template>
          <el-menu-item
            class="HeadText"
            index="/costBudget"
            v-if="haveSecond('0071_')"
            >收入及成本预算</el-menu-item
          >
          <el-menu-item
            class="HeadText"
            index="/paymentBudget"
            v-if="haveSecond('0072_')"
            >资金预算</el-menu-item
          >
          <el-menu-item
            class="HeadText"
            index="/budget"
            v-if="haveSecond('0073_')"
            >预算科目</el-menu-item
          >
        </el-sub-menu>
        <el-menu-item
          index="/dataExportIndex"
          v-if="
            department == '设计部' ||
            department == '采购部' ||
            department == '活动策划部' ||
            department == '商务部' ||
            department == '财务部' ||
            department == '软件工程部' ||
            department == '信息技术部'
          "
          >数据导出</el-menu-item
        >
      </el-menu>
    </div>
    <div class="navRight">
      <div class="userInfo">
        <a-popover position="br">
          <a-badge :count="noticeListNum">
            <a-button style="padding: 0px; background-color: #fff">
              <a-button type="text">
                <template #icon>
                  <icon-notification style="font-size: 20; color: #000" />
                </template>
              </a-button>
            </a-button>
          </a-badge>

          <template #content>
            <div class="notifyBox">
              <div class="notifyTitle">
                <span>通知</span>
                <a-button type="text" v-if="showAllButton" @click="getAllRead">
                  全部已读
                </a-button>
              </div>
              <div class="notifyBody">
                <a-list>
                  <a-list-item v-for="item in noticeList" :key="item.id">
                    <a-button
                      type="outline"
                      size="mini"
                      style="float: left; margin-right: 5px"
                      @click="getRead(item)"
                      >详情</a-button
                    >
                    <span v-if="item.noticeState" style="color: #67c23a"
                      >已读</span
                    >
                    <span v-else style="color: #f56c6c">未读</span>
                    {{ item.createDate + " " + item.noticeContent }}
                    <span> </span>
                  </a-list-item>
                </a-list>
              </div>
            </div>
          </template>
        </a-popover>
        <a-popover trigger="click" position="br">
          <a-button
            style="
              padding: 0px;
              margin: 0 20px;
              height: 35px;
              width: 35px;
              border-radius: 50%;
              background-color: #fff;
            "
          >
            <div class="userImg">
              <a-avatar :style="{ backgroundColor: '#7BC616' }" :sizeq="32">
                <img v-if="headPictureLocal" alt="avatar" :src="headPicture" />
                <span v-else>{{ userName.slice(1) }}</span>
              </a-avatar>
            </div>
          </a-button>
          <template #content>
            <a-button class="userItem" type="text" long @click="userInfo">
              <template #icon> <icon-user /></template>
              <template #default>个人资料</template>
            </a-button>
            <a-button class="userItem" type="text" long @click="modifyInfo">
              <template #icon><icon-edit /></template>
              <template #default>修改密码</template>
            </a-button>
            <a-button class="userItem" type="text" long @click="logOut">
              <template #icon> <icon-export /></template>
              <template #default>退出登录</template>
            </a-button>
          </template>
        </a-popover>
        <div style="margin-right: 35px; font-weight: 700; width: 100px">
          欢迎，{{ userName }}
        </div>
      </div>
    </div>
    <!-- <a-modal
      v-model:visible="noticeInfoShow"
      @ok="noticeOk"
      @cancel="noticeCancel"
    > -->
    <a-modal
      v-model:visible="noticeInfoShow"
      :hide-cancel="true"
      @ok="handleOk"
    >
      <template #title>
        {{
          noticeItem.noticeType == 1
            ? "通知公告"
            : noticeItem.noticeType == 2
            ? "项目邀请"
            : noticeItem.noticeType == 3
            ? "流程提醒"
            : ""
        }}
      </template>
      <div>
        <p>{{ noticeItem.projectName }}</p>
        <p>{{ noticeItem.noticeContent }}</p>
        <p>{{ noticeItem.createDate }}</p>
        <p>
          <span>{{ noticeItem.processName }}</span>
          <!-- <a-button
            type="outline"
            size="mini"
            style="margin-left: 5px"
            @click="getRead(item)"
            >前往处理</a-button
          > -->
        </p>
      </div>
    </a-modal>

    <a-modal
      :visible="visible"
      @ok="handleSubmit"
      @cancel="handleCancel"
      okText="确认修改"
      cancelText="取消"
      unmountOnClose
    >
      <template #title> 修改密码 </template>
      <div>
        <a-form ref="formRef" :rules="rules" :model="form">
          <a-form-item
            field="oldPasswor"
            label="原密码"
            validate-trigger="blur"
          >
            <a-input v-model="form.oldPasswor" placeholder="请输入原密码" />
          </a-form-item>
          <a-form-item
            field="newPassword"
            label="新密码"
            validate-trigger="blur"
          >
            <a-input-password
              v-model="form.newPassword"
              placeholder="请输入新密码"
            />
          </a-form-item>
          <a-form-item
            field="newPassword2"
            label="确认密码"
            validate-trigger="blur"
          >
            <a-input-password
              v-model="form.newPassword2"
              placeholder="请再次输入新密码"
            />
          </a-form-item>
        </a-form>
      </div>
    </a-modal>
  </div>
</template>

<script>
var setIntervalId = null;
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import baseApi from "@/api/baseApi"; //引入对应的api
import * as api from "@/api/api"; //引入对应的api
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      noticeItem: {},
      userAuthList: [],
      isShow: false,
      noticeList: [],
      showAllButton: false,
      noticeListNum: 0,
      noticeInfoShow: false,
      allAuth: localStorage.getItem("permissionIds")
        ? localStorage.getItem("permissionIds").split(",")
        : [],
      userName: localStorage.getItem("employeeName"),
      headPicture:
        baseApi.baseApi.FILEPATH + "/" + localStorage.getItem("headPicture"),
      headPictureLocal: localStorage.getItem("headPicture"),
      form: {
        oldPasswor: "",
        newPassword: "",
        newPassword2: "",
      },
      visible: false,
      rules: {
        oldPasswor: [
          {
            required: true,
            message: "请输入原密码",
          },
        ],
        newPassword: [
          {
            required: true,
            message: "请输入新密码",
          },
          {
            minLength: 6,
            message: "密码最小长度为6位",
          },
        ],
        newPassword2: [
          {
            required: true,
            message: "请再次输入新密码",
          },
          {
            validator: (value, cb) => {
              if (value !== this.form.newPassword2) {
                cb("两次输入密码不一致");
              } else {
                cb();
              }
            },
          },
        ],
      },
      //部门判断
      department: localStorage.getItem("department"),
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    setAuth() {
      let allAuth = localStorage.getItem("permissionIds").split(",")
        ? localStorage.getItem("permissionIds").split(",")
        : [];
      this.allAuth = allAuth;
    },
    // 一级菜单权限
    haveFirstAuth(num) {
      if (num == "001") {
        if (this.findMethods("0011_") || this.findMethods("0012_")) {
          return true;
        } else {
          return false;
        }
      } else if (num == "002") {
        if (this.findMethods("0021_")) {
          return true;
        } else {
          return false;
        }
      } else if (num == "003") {
        if (this.findMethods("0031_") || this.findMethods("0032_")) {
          return true;
        } else {
          return false;
        }
      } else if (num == "004") {
        if (this.findMethods("0041_") || this.findMethods("0042_")) {
          return true;
        } else {
        }
      } else if (num == "005") {
        if (this.findMethods("005_")) {
          return true;
        } else {
          return false;
        }
      } else if (num == "006") {
        return true;
      } else if (num == "007") {
        if (
          this.findMethods("0071_") ||
          this.findMethods("0072_") ||
          this.findMethods("0073_")
        ) {
          return true;
        } else {
          return false;
        }
      } else if (num == "009") {
        //数据导出模块权限需定义
      }
    },

    haveSecond(num) {
      if (this.findMethods(num)) {
        return true;
      } else {
        return false;
      }
    },

    findMethods(num) {
      return this.allAuth.find((e) => e.includes(num));
    },

    logOut() {
      localStorage.clear();
      this.$router.push({ path: "/" });
    },
    userInfo() {
      this.$router.push({ path: "/userInfo" });
    },
    modifyInfo() {
      this.visible = true;
    },
    handleSubmit() {
      this.visible = false;
      let params = {
        oldPasswor: this.form.oldPasswor,
        newPassword: this.form.newPassword,
      };
      api.savePassword(params).then((res) => {
        if (res.data.code == 0) {
          this.$notification.success("修改成功，请重新登陆！");
          this.handleCancel();
          setTimeout(() => {
            this.logOut();
          }, 1000);
        } else {
          this.$notification.error(res.data.msg);
        }
      });
    },
    handleCancel() {
      this.visible = false;
      this.form = {
        oldPasswor: "",
        newPassword: "",
        newPassword2: "",
      };
    },

    listNotice() {
      api.unreadNotice().then((res) => {
        this.noticeList = res.data.data ? res.data.data : [];
        this.noticeListNum = this.noticeList.length;
        if (
          this.noticeList.length > 0 &&
          this.noticeList.findIndex((item) => !item.noticeState) != -1
        ) {
          this.showAllButton = true;
        }

        // //清除定时器
        // if (this.noticeListNum == 0) {
        //   clearInterval(setIntervalId);
        // }else{
        //   setIntervalId = setInterval(() => {
        //     console.log('被调用定时器');
        //     // this.listNotice()
        //   }, 100000);
        // }
      });
    },

    handleOk() {
      this.noticeInfoShow = false;
      this.listNotice();
      window.location.reload();
    },

    getRead(item) {
      let param = {
        noticeId: item.id,
        processExecutionId: item.processExecutionId,
      };
      api.infoNotice(param).then((res) => {
        if (res.data.code == 0) {
          this.noticeItem = res.data.data;
          this.noticeInfoShow = true;
        } else {
          this.$notification.error(res.data.msg);
        }
      });
    },

    getAllRead() {
      let paramArr = [];
      this.noticeList.forEach((item) => {
        if (!item.noticeState) {
          paramArr.push(item.id);
        }
      });
      api.updateNoticeState({ noticeId: paramArr.join(",") }).then((res) => {
        if (res.data.code == 0) {
          this.$notification.success("一键已读成功！");
          setTimeout(() => {
            window.location.reload();
          }, 500);
        } else {
          this.$notification.error(res.data.msg);
        }
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.setAuth();
      }, 500);
    });
    this.listNotice();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.navBar {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;

  width: 100%;
  height: 60px;
  line-height: 60px;
  box-sizing: border-box;
  min-height: 60px;
  max-height: 60px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid var(--color-border);
  background-color: var(--color-bg-2);
}

.logo img {
  width: 30px;
  height: 30px;
  vertical-align: middle;
  margin-right: 10px;
}

.logo {
  font-size: 18px;
  font-weight: 700;
  margin: 0 0 0 20px;
  overflow: hidden;
}

.userImg {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  overflow: hidden;
}

.userImg img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.userInfo {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.userItem {
  height: 36px;
  width: 100px;
  color: #000;
}
.notifyTitle {
  display: flex;
  justify-content: space-between;
  align-items: center;

  width: 100%;
  height: 30px;
  border-bottom: 1px solid var(--color-border);
}
.notifyTitle /deep/ .arco-btn {
  font-size: 12px;
}
::v-deep .arco-btn-icon {
  margin-right: 0px !important;
}
.navRight {
  display: flex;
  justify-content: space-around;
}
.nav_left {
  display: flex;
  justify-content: left;
}
.el-menu-demo {
  margin-left: 40px;
}

.HeadText {
  font-size: 16px !important;
}
</style>